// Recovered compiled webpack factory 17045. Edit this function expression; run npm run build.
(e, t) => {
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "errorOnce", {
      enumerable: !0,
      get: function () {
        return n;
      },
    }));
  let n = (e) => {};
}
